import { type AxiosInstance } from 'axios'

interface ConnectionData {
  name?: string
  host: string
  port?: number
  username: string
  password?: string
}

interface ConnectionTestData {
  host: string
  port: number
  username: string
  password: string
}
export default (axios: AxiosInstance) => ({

  listAll() {
    return axios.get('/v1/sftp/')
  },
  create(data: ConnectionData) {
    return axios.post('/v1/sftp/', data)
  },
  editConnection(id: number, data: ConnectionData) {
    return axios.put(`/v1/sftp/${id}/`, data)
  },
  delete(id: number) {
    return axios.delete(`/v1/sftp/${id}/`)
  },
  testAccessWithData(data: ConnectionTestData) {
    return axios.post('/v1/sftp/test-ssh-access-with-data/', data)
  },
  testAccess(id: string) {
    return axios.get(`/v1/sftp/test-ssh-access/${id}/`)
  },

  getSftpAccess(connectId: number | string, path: string = '') {
    return axios.get(`/v1/sftp/sftp-access/${connectId}/${path}`)
  },
  fileDownload(fileId: number | string, filepath: string) {
    return axios.get(`/v1/sftp/file-download/${fileId}/${filepath}`, { responseType: 'arraybuffer' })
  },
  getSftp(pageParams = { page: 1, page_size: 15, sort_by_date: 'asc' }) {
    const { page, page_size } = pageParams
    let queryString = '?'
    if (!isNaN(page) && !isNaN(page_size)) {
      queryString += `page=${page}&page_size=${page_size}`
    }
    if (!isNaN(page) && isNaN(page_size)) {
      queryString += `page=${page}`
    }
    if (isNaN(page) && !isNaN(page_size)) {
      queryString += `page_size=${page_size}`
    }
    return axios.get(`/v1/sftp/${queryString}`)
  },

})
